import type { QuickAction } from '@moojo/domain-types'
import { LanguageCode } from '@moojo/domain-types'

export type LanguageContent = {
  name: string
  widgetPlacementSide: 'right' | 'left'
  direction: 'rtl' | 'ltr'
  quickActionText: Record<QuickAction, string>
  viewCouponLinkText: string
}

export const languageConfig: Record<LanguageCode, LanguageContent> = {
  en: {
    name: 'English',
    widgetPlacementSide: 'right',
    direction: 'ltr',
    quickActionText: {
      aboutTheBrand: 'About the Brand',
      aboutTheProduct: 'About the Product',
      similarBrandProducts: 'Similar Brand Products',
      followUsOnSocialMedia: 'Follow Us on Social Media',
      questionAboutProducts: `I have a question about the Brand's products`,
    },
    viewCouponLinkText: 'View coupon',
  },
  fr: {
    name: 'French',
    widgetPlacementSide: 'right',
    direction: 'ltr',
    quickActionText: {
      aboutTheBrand: 'À propos de la marque',
      aboutTheProduct: 'À propos du produit',
      similarBrandProducts: 'Produits similaires de la marque',
      followUsOnSocialMedia: 'Suivez-nous sur les réseaux sociaux',
      questionAboutProducts: `J'ai une question sur les produits de la marque`,
    },
    viewCouponLinkText: 'Voir le coupon',
  },
  he: {
    name: 'Hebrew',
    widgetPlacementSide: 'left',
    direction: 'rtl',
    quickActionText: {
      aboutTheBrand: 'על המותג',
      aboutTheProduct: 'על המוצר',
      similarBrandProducts: 'מוצרים דומים של המותג',
      followUsOnSocialMedia: 'עקבו אחרינו ברשתות החברתיות',
      questionAboutProducts: 'יש לי שאלה על מוצרי המותג',
    },
    viewCouponLinkText: 'צפה בקופון',
  },
}

// 'en-GB' => 'en', 'EN-GB' => 'en', 'EN' => 'en'
export const normalizeLang = (input: string) => input.split('-')[0].toLowerCase().trim()

export const parseOr = (input: string | undefined, fallback: LanguageCode) => {
  const maybeParsed = LanguageCode.safeParse(input ? normalizeLang(input) : input)
  return maybeParsed.success ? maybeParsed.data : fallback
}

export const langConfigForRawLang = (rawLang: string) => languageConfig[parseOr(normalizeLang(rawLang), 'en')]
